import { render, staticRenderFns } from "./JobSearchPreviewDetailSp.vue?vue&type=template&id=2d672686&scoped=true"
import script from "./JobSearchPreviewDetailSp.vue?vue&type=script&lang=js"
export * from "./JobSearchPreviewDetailSp.vue?vue&type=script&lang=js"
import style0 from "./JobSearchPreviewDetailSp.vue?vue&type=style&index=0&id=2d672686&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d672686",
  null
  
)

export default component.exports